// Fee-waiver notice content (SOR-129 R6; D4 places the notice on Review
// because this wizard has no payment step). The copy awaits Walter's final
// sign-off — a wording change is an edit to this single constant, nowhere else.
//
// Kept dependency-free (no workspace imports) so the spec property probes
// under internal/proptests can compile this source directly, mirroring
// categoryGate.ts.

export const FEE_WAIVER_NOTICE = {
  heading: 'Payment information is not required for eFiling Fee Waiver parties.',
  body: 'Fee Waiver Status will be verified when you place your filing.',
  qualifications:
    'Qualifications for Court Fee Waivers include: you are a low-income person, receiving public benefits, do not have enough income to pay household basic needs and your court fees.',
} as const;

/** The wizard step hosting the notice — step 3, Review. */
export const REVIEW_STEP = 3;

// R6: the notice renders iff the wizard is on Review and the selected category
// is eFiling Fee Waiver (Pro Per). The literal matches the shared-contracts
// vocabulary member; the r6 spec property locks the two against drift.
export function showsFeeWaiverNotice(step: number, selectedCategory: string): boolean {
  return step === REVIEW_STEP && selectedCategory === 'efiling_fee_waiver_pro_per';
}
